module.exports = __webpack_public_path__ + "img/font-icon-Enerdata.d1d6ac4.svg";